module.exports = __webpack_public_path__ + "static/media/year_end_settlement_upload.d000512c.svg";